<template>
	<div>
		<a-modal :title="$t('studentsCom.tradingOrder')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
			:pagination="false">
			<div class="ftr-1 cl-black">
				<div class="cl-info">
					<!-- 上傅證摅由平台決定 -->
					{{$t('studentsCom.uploadDataDecision')}}
				</div>
				<div class="mt-4">
					<!-- 解釋和證明 -->
					{{$t('studentsCom.explanationAndProof')}}
				</div>
				<div class="cl-info">
					<!-- 如果你有任何證據支持你的請求，請盏可能多的提供，以得最佳结果 -->
					{{$t('studentsCom.uploadEvidenceTip')}}
				</div>
				<textarea class="mt-3 border-gray wid-100 p-2 br4" style="height: 150px;" :placeholder="$t('common.select')"></textarea>
				
				<div class="mt-3 border-gray wid-100 text-center py-2">
					{{$t('studentsCom.uploadImage')}}
				</div>
				<div class="mt-4 d-flex justify-content-center">
					<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel()">{{$t('common.cancel')}}</button>
					<button type="button" class="btn btn-theme ml16 px-4">{{$t('common.submit')}}</button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				codeLoading: false,
				account: '',
				rate:3
			}
		},
		created() {
	
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
	
		}
	}
</script>

<style>
</style>